exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad[data-v-18cd3eca] {\r\n  padding: 1em;\n}\r\n", ""]);

// exports
